import React from "react";

import { loader, loaderVariants } from "./spinner.css";

export function Spinner({ colorVariant = "dark" }) {
  return <div className={`${loader} ${loaderVariants[colorVariant]}`}></div>;
}
